class VipTiers {
  constructor(
    vipTiers,
    currentStatusLabel,
    benefitHeaders,
    tierSpend,
    benefitsList,
    customer
  ) {
    this.vipTiers = vipTiers;
    this.currentStatusLabel = currentStatusLabel;
    this.benefitHeaders = benefitHeaders;
    this.tierSpend = tierSpend;
    this.benefitsList = benefitsList;
    this.customer = customer;
  }

  renderVipTiers() {
    console.log("renderVipTiers is running");

    $(".yotpo-vip-container").append(
      $("<div>")
        .addClass("yotpo-benefit-headers")
        .append(
          $("<div>").addClass("yotpo-vip-tier-spacing"),
          $("<div>")
            .addClass("yotpo-benefit-headers-list-item")
            .addClass("yotpo-benefit-list-header")
            .text(this.tierSpend),
          $("<div>").addClass("yotpo-vip-tier-benefits-headers-container")
        ),
      $("<div>").addClass("yotpo-benefit-list"),
      $("<div>").addClass("yotpo-slick-arrows-container")
    );
    //*******************headers column**********************
    this.benefitHeaders.forEach((header) => {
      $(".yotpo-vip-tier-benefits-headers-container").append(
        $("<div>").addClass("yotpo-benefit-headers-list-item").text(header)
      );
    });

    // ***************creates the 4 columns - one for each tier******************
    this.benefitsList.forEach((benefit) => {
      $(".yotpo-benefit-list").append(
        $("<div>", {
          class: `yotpo-vip-tier-item-${benefit.tierId}`,
        })
          .addClass("yotpo-vip-tier")
          .append(
            $("<div>")
              .addClass("yotpo-vip-tier-header-container")
              .append(
                $("<div>")
                  .addClass("yotpo-vip-tier-status-container")
                  .append(
                    $("<div>").addClass(
                      "yotpo-vip-tier-current-status-container"
                    ),
                    $("<div>").addClass(
                      "yotpo-vip-tier-next-requirement-container"
                    )
                  ),
                $("<div>")
                  .addClass("yotpo-vip-tier-content-container")
                  .append(
                    $("<div>").addClass("yotpo-tier-rank").text(`Tier ${this.getVipTierRank(benefit.tierId)}`),
                    $("<div>").addClass("yotpo-vip-tier-benefit-item").addClass("yotpo-vip-tier-name").text(this.getVipTierName(benefit.tierId)),
                    $("<div>")
                      .addClass("yotpo-vip-tier-requirement")
                      .text(benefit.tierRequirement),
                    $("<div>").addClass("yotpo-vip-tier-benefits-container")
                  )
              )
          )
      );

      benefit.benefits.forEach((item) => {
        $(
          `.yotpo-vip-tier-item-${benefit.tierId} .yotpo-vip-tier-benefits-container`
        ).append($("<div>").addClass("yotpo-vip-tier-benefit-item").text(item));
      });
    });

    this.makeSlick();
    this.replaceCheck();
    this.getNextTierName();
  }

  // });

  // 	}

  replaceCheck() {
    $("div.yotpo-vip-tier-benefit-item:contains('☀')")
      .text("").append(
        $("<div>").addClass("yotpo-benefit-icon")
      );


  }

  getVipTierName(id) {
    return this.vipTiers[this.vipTiers.map((tier) => tier.id).indexOf(id)].name;
  }
  getVipTierRank(id) {
    console.log("getVipTierRank")
    return (this.vipTiers[this.vipTiers.map((tier) => tier.id).indexOf(id)].rank) + 1;   
  }
  
  getVipTierDivLocation() {
    return (
      this.vipTiers
        .map((tier) => tier.name)
        .indexOf(this.customer.vipTier.name) + 1);
  }

  renderCurrentStatus() {
    if (this.customer.created_at !== undefined) {
     
      $(
        `.yotpo-benefit-list .yotpo-vip-tier:nth-of-type(${this.getVipTierDivLocation()}) .yotpo-vip-tier-current-status-container`
      ).text(this.currentStatusLabel);
      $(
        `.yotpo-vip-tier:nth-of-type(${this.getVipTierDivLocation()})`
      ).addClass("yotpo-current-status-bg");
    }

    if (this.customer.vipTier === null) {
       $(".yotpo-current-vip-level-value").addClass("yotpo-hide");
    }
  }

  getNextTierName() {
        let nextTierName = "";
    let tierNames = this.vipTiers.map((tier) => tier.name);
    let currentTierIndex = tierNames.indexOf(this.customer.vipTier.name);
    let nextTierIndex = this.vipTiers[tierNames.indexOf(this.customer.vipTier.name) + 1]
 console.log(`  tier index ${nextTierIndex}`) 
     if (currentTierIndex < tierNames.length - 1) {
       nextTierName =  this.vipTiers[tierNames.indexOf(this.customer.vipTier.name) + 1].name;
     }
    }



  makeSlick() {
    if (
      Array.from(document.querySelectorAll("script")).filter((script) =>
        script.src.includes("slick")
      ).length < 1
    ) {
      var newscript = document.createElement("script");
      newscript.type = "text/javascript";
      newscript.async = true;
      newscript.src =
        "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
      (
        document.getElementsByTagName("head")[0] ||
        document.getElementsByTagName("body")[0]
      ).appendChild(newscript);
    }

    if ($(window).width() > 1025) {
      
    } else {
         setTimeout(function () {
      $(".yotpo-benefit-list").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
          dots: true, 
            arrows: false,
        adaptiveHeight: true,
       appendDots: $('.loyalty-slick-nav-container'),
        responsive: [
          {
            breakpoint: 530,
            settings: {
              slidesToShow: 1,
             dots: true, 
            arrows: false
            },
          },
        ],
      });
    }, 1000);
    }

  }
}
